import { Injectable } from '@angular/core';
import { Actions, Effect, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action, Store } from '@ngrx/store';

import * as fromRoot from '../reducers';
import { TestContentService } from '../../services/test-content.service';
import { TestTakerActions, AppUiActions } from '../actions';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Injectable()
export class TestTakerEffects {
    constructor(
        private store: Store<fromRoot.State>,
        private testContentService: TestContentService,
        private actions$: Actions
    ) { }

    @Effect() loadTestlet$: Observable<Action> = this.actions$.ofType(TestTakerActions.LOAD_TESTLET)
        .do(x => this.store.dispatch(new AppUiActions.ShowLoadingOverlay()))
        .map(toPayload)
        .switchMap(payload => this.testContentService.getTestlet(payload.testletId, payload.assessmentTestId)
            .map(testlet => new TestTakerActions.LoadTestletSuccess(testlet))
        )
        .do(x => this.store.dispatch(new AppUiActions.HideLoadingOverlay()));

    @Effect() preloadTestlet$: Observable<Action> = this.actions$.ofType(TestTakerActions.PRELOAD_TESTLET)
        .map(toPayload)
        .switchMap(payload => this.testContentService.getTestlet(payload.testletId, payload.assessmentTestId)
            .map(testlet => new TestTakerActions.PreloadTestletSuccess(testlet))
        );

    @Effect() loadSnapShotTestlet$: Observable<Action> = this.actions$.ofType(TestTakerActions.LOAD_SNAPSHOT_TESTLET)
        .do(x => this.store.dispatch(new AppUiActions.ShowLoadingOverlay()))
        .map(toPayload)
        .switchMap(testletId => this.testContentService.getSnapshotTestlet(testletId)
            .map(testlet => new TestTakerActions.LoadTestletSuccess(testlet.TestletDetail.TestletDefinition))
        )
        .do(x => this.store.dispatch(new AppUiActions.HideLoadingOverlay()));

    @Effect() loadAssessmentTestByTestForm$: Observable<Action> = this.actions$.ofType(TestTakerActions.LOAD_ASSESSMENT_TEST_BY_TEST_FORM)
        .do(x => this.store.dispatch(new AppUiActions.ShowLoadingOverlay()))
        .map(toPayload)
        .switchMap(testFormId => this.testContentService.getAssessmentTestByTestFormId(testFormId)
            .map(assessmentTest => new TestTakerActions.LoadAssessmentTestSuccess(assessmentTest))
        )
        .do(x => this.store.dispatch(new AppUiActions.HideLoadingOverlay()));

    @Effect() loadAssessmentTest$: Observable<Action> = this.actions$.ofType(TestTakerActions.LOAD_ASSESSMENT_TEST)
        .do(x => this.store.dispatch(new AppUiActions.ShowLoadingOverlay()))
        .map(toPayload)
        .switchMap(assessmentTestId => this.testContentService.getAssessmentTest(assessmentTestId)
            .map(assessmentTest => new TestTakerActions.LoadAssessmentTestSuccess(assessmentTest))
        )
        .do(x => this.store.dispatch(new AppUiActions.HideLoadingOverlay()));

    @Effect() loadTestletVersion$: Observable<Action> = this.actions$.ofType(TestTakerActions.LOAD_TESTLET_VERSION)
        .do(x => this.store.dispatch(new AppUiActions.ShowLoadingOverlay()))
        .map(toPayload)
        .switchMap(testletVersionId => this.testContentService.getTestletVersion(testletVersionId)
            .map(testlet => new TestTakerActions.LoadTestletSuccess(testlet))
        )
        .do(x => this.store.dispatch(new AppUiActions.HideLoadingOverlay()));

    @Effect() loadIppAssessmentTest$: Observable<Action> = this.actions$.ofType(TestTakerActions.LOAD_IPP_ASSESSMENT_TEST)
        .do(x => this.store.dispatch(new AppUiActions.ShowLoadingOverlay()))
        .map(toPayload)
        .switchMap(ippAssessmentTestId => this.testContentService.getIppAssessmentTest(ippAssessmentTestId)
            .map(ippAssessmentTest => new TestTakerActions.LoadAssessmentTestSuccess(ippAssessmentTest.IppAssessmentTest))
        )
        .do(x => this.store.dispatch(new AppUiActions.HideLoadingOverlay()));

    @Effect() loadLatestIppAssessmentTest$: Observable<Action> = this.actions$.ofType(TestTakerActions.LOAD_LATEST_IPP_ASSESSMENT_TEST)
        .do(x => this.store.dispatch(new AppUiActions.ShowLoadingOverlay()))
        .map(toPayload)
        .switchMap(ippAssessmentTestId => this.testContentService.getIppAssessmentTest(ippAssessmentTestId)
            .map(ippAssessmentTest => new TestTakerActions.LoadAssessmentTestSuccess(ippAssessmentTest.IppAssessmentTest))
        )
        .do(x => this.store.dispatch(new AppUiActions.HideLoadingOverlay()));

    @Effect() loadIppProduct$: Observable<Action> = this.actions$.ofType(TestTakerActions.LOAD_IPP_PRODUCT)
        .do(x => this.store.dispatch(new AppUiActions.ShowLoadingOverlay()))
        .map(toPayload)
        .switchMap(productId => this.testContentService.getIppAssessmentTestByProductId(productId)
            .mergeMap(dto => {
                return Observable.from([
                    new TestTakerActions.SetIppProductInfo(dto),
                    new TestTakerActions.LoadAssessmentTestSuccess(dto.IppAssessmentTest)
                ]);
            })
        )
        .do(x => this.store.dispatch(new AppUiActions.HideLoadingOverlay()));
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/effects/test-taker.effect.ts